export function extractCCEmails(emails = [] || "") {
    let ccEmails = [];

    if (Array.isArray(emails)) {
        ccEmails = emails;
    }  
    
    if (typeof emails === "string") {
        ccEmails = emails.split(",");
    }
    
    return ccEmails;
}